import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    matchId: Number
  }

  connect() {
    // Scroll to bottom when connecting
    this.scrollToBottom()
    
    // Set up observer to scroll on new messages
    this.observeMessages()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    const container = document.getElementById('messagesContainer')
    if (container) {
      container.scrollTop = container.scrollHeight
    }
  }

  observeMessages() {
    const messagesDiv = document.getElementById('messages')
    if (!messagesDiv) return

    // Create a MutationObserver to watch for new messages
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          this.scrollToBottom()
        }
      })
    })

    // Start observing
    this.observer.observe(messagesDiv, {
      childList: true,
      subtree: true
    })
  }
}

